import {props} from '@ngrx/store';
import {createActionWithCorrelation} from '@kion/ngrx-helper';
import {Basket, DeliveryMethod, Order, Payment, PaymentInfo} from '@kion/data-models';

export const loadAllSuccess = createActionWithCorrelation(
  "[Basket] loadAll Success",
  props<{ baskets: Basket[] }>()
);
export const loadAllError = createActionWithCorrelation(
  "[Basket] loadAll Error",
  props<{error: any}>()
);
export const loadAll = createActionWithCorrelation(
  "[Basket] loadAll",
  loadAllSuccess.type,
  loadAllError.type
);

export const createOrFindBasketSuccess = createActionWithCorrelation(
  "[Basket] create or find basket success",
  props<{ basket: Basket }>()
);
export const createOrFindBasketError = createActionWithCorrelation(
  "[Basket] create or find basket error",
  props<{ error: any }>()
);
export const createOrFindBasket = createActionWithCorrelation(
  "[Basket] create or find basket",
  props<{ userId?: string, basketId?: string }>(),
  createOrFindBasketSuccess.type,
  createOrFindBasketError.type
);

export const loadByIdSuccess = createActionWithCorrelation(
  "[Basket] load by id success",
  props<{ basket: Basket }>()
);
export const loadByIdError = createActionWithCorrelation(
  "[Basket] load by id error",
  props<{ error: any }>()
);
export const loadById = createActionWithCorrelation(
  "[Basket] load by id",
  props<{ basketId: string, userId?: string }>(),
  loadByIdSuccess.type,
  loadByIdError.type
);

export const addToBasketSuccess = createActionWithCorrelation(
  "[Basket] add to basket success",
  props<{ basket: Basket }>()
);
export const addToBasketError = createActionWithCorrelation(
  "[Basket] add to basket error",
  props<{ error: any }>()
);
export const addToBasket = createActionWithCorrelation(
  "[Basket] add to basket",
  props<{ basketId: string, productId: string, qty: number, options: {code: string}[], userId?: string }>(),
  addToBasketSuccess.type,
  addToBasketError.type
);
export const addToBasketWithUnit = createActionWithCorrelation(
  "[Basket] add to basket with unit",
  props<{ basketId: string, productId: string, qty: number, unitIso?: string, options: {code: string}[], userId?: string }>(),
  addToBasketSuccess.type,
  addToBasketError.type
);

export const loadDeliveryDataByBasketSuccess = createActionWithCorrelation(
  "[Basket] load delivery data success",
  props<{ deliveryMethods: DeliveryMethod[] }>()
);
export const loadDeliveryDataByBasketError = createActionWithCorrelation(
  "[Basket] load delivery data error",
  props<{ error: any }>()
);
export const loadDeliveryDataByBasket = createActionWithCorrelation(
  "[Basket] load delivery data",
  props<{ basketId: string, userId?: string }>(),
  loadDeliveryDataByBasketSuccess.type,
  loadDeliveryDataByBasketError.type
);

export const setDeliveryMethodSuccess = createActionWithCorrelation(
  "[Basket] set delivery method success",
  props<{ basket: Basket }>()
);
export const setDeliveryMethodError = createActionWithCorrelation(
  "[Basket] set delivery method error",
  props<{ error: any }>()
);
export const setDeliveryMethod = createActionWithCorrelation(
  "[Basket] set delivery method",
  props<{ basketId: string, deliveryMethod: DeliveryMethod, userId?: string }>(),
  setDeliveryMethodSuccess.type,
  setDeliveryMethodError.type
);

export const addEmailToBasketSuccess = createActionWithCorrelation(
  "[Basket] add email to basket success",
  props<{ basket: Basket }>()
);
export const addEmailToBasketError = createActionWithCorrelation(
  "[Basket] add email to basket error",
  props<{ error: any }>()
);
export const addEmailToBasket = createActionWithCorrelation(
  "[Basket] add email to basket",
  props<{ basketId: string, email: string, userId?: string }>(),
  addEmailToBasketSuccess.type,
  addEmailToBasketError.type
);

export const loadPaymentMethodsSuccess = createActionWithCorrelation(
  "[Basket] load payment methods success",
  props<{ payments: Payment[] }>()
);
export const loadPaymentMethodsError = createActionWithCorrelation(
  "[Basket] load payment methods error",
  props<{ error: any }>()
);
export const loadPaymentMethods = createActionWithCorrelation(
  "[Basket] load all payment methods",
  loadPaymentMethodsSuccess.type,
  loadPaymentMethodsError.type
);

export const loadSupportedPaymentMethodsSuccess = createActionWithCorrelation(
  "[Basket] load dematic related payment methods success",
  props<{ payments: Payment[] }>()
);
export const loadSupportedPaymentMethodsError = createActionWithCorrelation(
  "[Basket] load payment methods error",
  props<{ error: any }>()
);
export const loadSupportedPaymentMethods = createActionWithCorrelation(
  "[Basket] load payment methods",
  loadPaymentMethodsSuccess.type,
  loadPaymentMethodsError.type
);

export const setPaymentInfoSuccess = createActionWithCorrelation(
  "[Basket] set payment success",
  props<{ basket: Basket }>()
);
export const setPaymentInfoError = createActionWithCorrelation(
  "[Basket] set payment error",
  props<{ error: any }>()
);
export const setPaymentInfo = createActionWithCorrelation(
  "[Basket] set payment",
  props<{ basketId: string, payment: Partial<PaymentInfo>, userId?: string }>(),
  setPaymentInfoSuccess.type,
  setPaymentInfoError.type
);

export const placeOrderSuccess = createActionWithCorrelation(
  "[Basket] place order success",
  props<{ order: Order }>()
);
export const placeOrderError = createActionWithCorrelation(
  "[Basket] place order error",
  props<{ error: any }>()
);
export const placeOrder = createActionWithCorrelation(
  "[Basket] place order",
  props<{ basketId: string, userId?: string}>(),
  placeOrderSuccess.type,
  placeOrderError.type
);

export const finalizePaymentSuccess = createActionWithCorrelation(
  "[Basket] finalize payment success",
  props<{order: Order}>()
);
export const finalizePaymentError = createActionWithCorrelation(
  "[Basket] finalize payment error",
  props<{ error: any }>()
);
export const finalizePayment = createActionWithCorrelation(
  "[Basket] finalize payment",
  props<{ basketId: string, transactionId: string, userId?: string }>(),
  finalizePaymentSuccess.type,
  finalizePaymentError.type
);

export const changeQuantitySuccess = createActionWithCorrelation(
  "[Basket] change quantity success",
  props<{ basket: Basket }>()
);
export const changeQuantityError = createActionWithCorrelation(
  "[Basket] change quantity error",
  props<{ error: any }>()
);
export const changeQuantity = createActionWithCorrelation(
  "[Basket] change quantity",
  props<{ basketId: string, entryNumber: string, quantity: number }>(),
  changeQuantitySuccess.type,
  changeQuantityError.type
);

export const deleteEntrySuccess = createActionWithCorrelation(
  "[Basket] delete entry success",
  props<{ basket: Basket }>()
);
export const deleteEntryError = createActionWithCorrelation(
  "[Basket] delete entry error",
  props<{ error: any }>()
);
export const deleteEntry = createActionWithCorrelation(
  "[Basket] delete entry",
  props<{ basketId: string, entryNumber: string }>(),
  deleteEntrySuccess.type,
  deleteEntryError.type
);

export const transformAnonymousToPersonalSuccess = createActionWithCorrelation(
  "[Basket] transform anonymous to personal success",
  props<{ basket: Basket }>()
);
export const transformAnonymousToPersonalError = createActionWithCorrelation(
  "[Basket] transform anonymous to personal error",
  props<{ error: any }>()
);
export const transformAnonymousToPersonal = createActionWithCorrelation(
  "[Basket] transform anonymous to personal",
  props<{ userId: string, oldBasketId: string }>(),
  transformAnonymousToPersonalSuccess.type,
  transformAnonymousToPersonalError.type
);

export const addUserReferenceSuccess = createActionWithCorrelation(
  "[Basket] add user reference success",
  props<{ basket: Basket }>()
);
export const addUserReferenceError = createActionWithCorrelation(
  "[Basket] add user reference error",
  props<{ error: any }>()
);
export const addUserReference = createActionWithCorrelation(
  "[Basket] add user reference",
  props<{ basketId: string, userReference: string }>(),
  addUserReferenceSuccess.type,
  addUserReferenceError.type
);

export const setAddressSuccess = createActionWithCorrelation(
  "[Basket] set address success",
  props<{ basket: Basket }>()
);
export const setAddressError = createActionWithCorrelation(
  "[Basket] set address error",
  props<{ error: any }>()
);
export const setAddress = createActionWithCorrelation(
  "[Basket] set address",
  props<{ basketId: string, isDeliveryAddress: boolean, addressId: string}>(),
  setAddressSuccess.type,
  setAddressError.type
);

export const addPromotionCodeSuccess = createActionWithCorrelation(
  "[Basket] add promotion success",
  props<{ basket: Basket  }>()
);
export const addPromotionCodeError = createActionWithCorrelation(
  "[Basket] add promotion error",
  props<{ error: any }>()
);
export const addPromotionCode = createActionWithCorrelation(
  "[Basket] add promotion",
  props<{ basketId: string, promotionCode: string}>(),
  addPromotionCodeSuccess.type,
  addPromotionCodeError.type
);

export const deletePromotionCodeSuccess = createActionWithCorrelation(
  "[Basket] delete promotion success",
  props<{ basket: Basket  }>()
);
export const deletePromotionCodeError = createActionWithCorrelation(
  "[Basket] delete promotion error",
  props<{ error: any }>()
);
export const deletePromotionCode = createActionWithCorrelation(
  "[Basket] delete promotion",
  props<{ basketId: string, promotionCode: string}>(),
  deletePromotionCodeSuccess.type,
  deletePromotionCodeError.type
);

export const checkStepSuccess = createActionWithCorrelation(
  "[Basket] check step success",
  props<{step: string}>()
);
export const checkStepError = createActionWithCorrelation(
  "[Basket] check step error",
  props<{ error: any }>()
);
export const checkStep = createActionWithCorrelation(
  "[Basket] check step",
  checkStepSuccess.type,
  checkStepError.type
);

export const updatePurchaseOrderNumberSuccess = createActionWithCorrelation(
  "[Basket] update purchase order number success",
  props<{ basket: Basket }>()
);
export const updatePurchaseOrderNumberError = createActionWithCorrelation(
  "[Basket] update purchase order number error",
  props<{ error: any }>()
);
export const updatePurchaseOrderNumber = createActionWithCorrelation(
  "[Basket] update purchase order number",
  props<{ basketId: string, purchaseOrderNumber: string }>(),
  updatePurchaseOrderNumberSuccess.type,
  updatePurchaseOrderNumberError.type
);

export const applyPostalCodeMappingSuccess = createActionWithCorrelation(
  "[Basket] trigger postal code mapping"
)

export const applyPostalCodeMappingError = createActionWithCorrelation(
  "[Basket] trigger postal code mapping Error",
  props<{ error: any }>()
)

export const applyPostalCodeMapping = createActionWithCorrelation(
  "[Basket] trigger postal code mapping Success",
  props<{ basketId: string }>(),
  applyPostalCodeMappingSuccess.type,
  applyPostalCodeMappingError.type
)

export const setCompleteDeliverySuccess = createActionWithCorrelation(
  "[Basket] set complete delivery mapping"
)

export const setCompleteDeliveryError = createActionWithCorrelation(
  "[Basket] set complete delivery Error",
  props<{ error: any }>()
)

export const setCompleteDelivery = createActionWithCorrelation(
  "[Basket] set complete delivery",
  props<{ userId?: string,basketId: string, completeDelivery: boolean }>(),
  setCompleteDeliverySuccess.type,
  setCompleteDeliveryError.type
)

